import React from "react";

import Button from '@material-ui/core/Button';
import PublishIcon from '@material-ui/icons/Publish';

export const PublishButton = (props) => {
	return <Button variant="success" style={{ margin: "2vh", minWidth: "10vw" }} startIcon={<PublishIcon />} {...props}>Pubblica</Button>;
}